export const activitesTabsList = [
  {
    id: "recent-attended-lecture",
    label: "Recently Attended Lectures",
  },
  {
    id: "practice-performance",
    label: "Practice Performance",
  },
  {
    id: "test-performance",
    label: "Test Performance",
  },
  {
    id: "full-length-exams",
    label: "Full-Length Exams",
  },
];
